<section class="categories-wrp christmasTheme">
  <div class="container">
    <div class="categories-wrp-inner">
      <div class="text-info text-center colorWhite">
        <!--31 Oct-->
        <h4>Exclusive Experiences by <span>Things<span class="large-font">2</span>do</span>
        </h4>
        <p>Encounter a world of specially curated experiences that promise to make your memories more magical. </p>
        <div class="line-black"></div>
        <h3>Explore Moods</h3>
      </div>
<div  uk-slider="finite: true" class="uk-position-relative">
      <div class="filter-new-card-wrp uk-flex uk-flex-between mt-4 mb-4 uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m uk-grid">
        <div class="filter-new-card" *ngFor="let category of categories.EXPERIENCE">
          <div
            class="uk-inline uk-dark cursor-pointer {{selectedCategoryIDs.includes(category.id) || category.slug == currentCategorySlug? ' uk-box-shadow-bottom active':''}}"
            (click)="filterProducts(category.id,false)" href="#categoryScroll">
            <img src="{{category.category_image}}" class="image">
            <div class="uk-overlay-default uk-position-cover">
              <div class="uk-position-center">
                <a>
                  <h5>
                    {{category.category_name}}
                  </h5>
                </a>
              </div>
            </div>
            <div class="close" (click)="unSelectCategory(category.id)">
              x
            </div>
          </div>
        </div>
      
         </div>
         <a class="uk-position-center-left uk-position-small uk-hidden-hover" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
         <a class="uk-position-center-right uk-position-small uk-hidden-hover" href="#" uk-slidenav-next uk-slider-item="next"></a>
      
        </div>
    </div>
  </div>
  <!--container--->
</section>

<!-- Experiences Section -->
<a id="category"></a>
<section class="experience-wrp" id="categoryScroll">
  <div class="container">

    <div class="categories-listing-1">
      <div *ngIf="responseReceived" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50"
           (scrolled)="onScroll()">

        <app-product-card class="uk-flex uk-flex-wrap experience-wrp-inner" [data]="products">
        </app-product-card>
        <!-- listing-card -->
      </div>

      <div class="uk-flex uk-flex-wrap experience-wrp-inner" *ngIf="!responseReceived">
        <div class="listing-card" *ngFor="let product of [1,2,3,4,5,6,7,8,9]">
          <div class="imageVideo">
            <div class="image">
              <div class="video">
                <ngx-skeleton-loader count="5" [theme]="{ 'border-radius': '0', height: '100vh' }">
                </ngx-skeleton-loader>
              </div>
              <div class="voice">
                <img src="assets/images/icons/sound.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- categories-listing-1 -->

  </div>
</section>

<section class="camera-len-wrp">
  <div class="camera-len mt-100">
    <img class="categories-img" data-src="assets/images/icons/lens.png" uk-img>
    <h4>Damn You’re a Scroller!</h4>
    <p>Curating experiences that are cooler!</p>
  </div>
</section>


<!--Filters & modals--->
<div class="filter-floating-btn hidelg">
  <a href="javascript:void(0)" class="openFilterClick">
    <img src="assets/images/icons/filter-icon.png" alt="">
  </a>
</div>

<div class="filter-card-wrp filteropen hidelg">
  <div class="filter-card-wrp-inner">
    <div class="close-btn">
      <a href="javascript:void(0)" class="closeFilter"><img src="assets/images/icons/close.png" alt=""></a>
    </div>
    <div class="filter-card">
      <h4 class="heading">Exclusive Experiences</h4>


      <div class="categories-wrp">
        <div class="categories-slider">

          <div uk-slider>
            <div class="uk-position-relative">

              <div class="uk-slider-container uk-light">
                <ul class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-5@m"
                    *ngIf="categoriesReceived">

                  <li *ngFor="let category of categories.EXPERIENCE"
                      [routerLink]="['/'+selectedCity+'/exclusives/'+category.category_name.toLowerCase()]"
                      class="{{currentCategoryID === category.id || category.category_name.toLowerCase() == currentCategorySlug? 'active uk-active':''}}">
                    <img class="categories-img" src="{{category.category_image}}" width="275" height="200"
                         alt="{{category.category_name}}">
                    <div class="uk-position-center uk-panel">
                      <h4>{{category.category_name}}</h4>
                    </div>
                  </li>

                </ul>
              </div>
              <!--uk-slider-container--->
            </div>
          </div>

        </div>
        <!--categories-slider--->
      </div>
      <!--categories-wrp--->

    </div>
  </div>
</div>
